<template>
    <div class="check_summary_normal_layout">
        <div v-show="show_contents" v-for="(consignee_grouped_core_waybills, consignee_company_name) in _.groupBy(check_core_waybills, 'consignee_company_name')">
            <div ref="printable_check_summaries" class="divided">
                <h2 class="ui center aligned header">
                    <div class="content">
                        {{ title }}
                    </div>
                </h2>
                <h4 class="ui center aligned header">
                    <!-- {{ $store.state.provider.node.company_name }}
                     -> -->
                    {{ (consignee_company_name == 'null' || consignee_company_name == null) ? '':consignee_company_name }}
                </h4>
                <span>收執聯</span><br>
                <span>點交時間： {{ human_datetime(Date.now(), "YYYY-MM-DD HH:mm") }}</span><br>
                <span>點交件數： {{ (consignee_grouped_core_waybills.length).toLocaleString() }}件</span><br>
                <span v-for="(cws, operation_identity) in _.groupBy(consignee_grouped_core_waybills, 'operation.identity')">
                    <span v-if="operation_identity && cws[0].operation">
                        <p>訂單：{{ cws[0].operation.number }}({{cws.length}}件)</p>
                    </span>
                    <span v-else>
                        <p>訂單：-</p>
                    </span>
                    <div class="ui basic black mini label" v-for="(core_waybill, index) in cws" style="margin:0;">
                        {{ index+1 }}. {{ core_waybill.material.class_name == "House" ? core_waybill.number : core_waybill.original_number }}@{{ latest_status_time(core_waybill) }}
                    </div>
                </span>
                <h4>簽名欄</h4>
                <div style="width: 100%; height: 2cm; border-bottom: 2px solid; position: relative;">
                    <i style="font-size: 14px; color: lightgray; position: absolute; right: 0px; bottom: 0px;">請於此線簽名</i>
                </div>
            </div>
            <!-- <div ref="printable_check_summaries" class="divided">
                <h2 class="ui center aligned header">
                    <div class="content">
                        {{ title }}
                    </div>
                </h2>
                <h4 class="ui center aligned header">
                    {{ (consignee_company_name == 'null' || consignee_company_name == null) ? '':consignee_company_name }}
                </h4>
                <span>收貨方收執聯</span><br>
                <span>點交時間： {{ human_datetime(Date.now(), "YYYY-MM-DD HH:mm") }}</span><br>
                <span>點交件數： {{ (consignee_grouped_core_waybills.length).toLocaleString() }}件</span><br>
                <span v-for="(cws, operation_identity) in _.groupBy(consignee_grouped_core_waybills, 'operation.identity')">
                    <span v-if="operation_identity && cws[0].operation">
                        <p>訂單： {{ cws[0].operation.number }}({{cws.length}}件)</p>
                    </span>
                    <span v-else>
                        <p>訂單：?</p>
                    </span>
                    <div class="ui basic black mini label" v-for="(core_waybill, index) in cws" style="margin:0;">
                        {{ index+1 }}.{{ core_waybill.number }}@{{ latest_condition_time(core_waybill) }}
                    </div>
                </span>
                <h4>交貨方簽名欄</h4>
                <div style="width: 100%; height: 2cm; border-bottom: 2px solid; position: relative;">
                    <i style="font-size: 14px; color: lightgray; position: absolute; right: 0px; bottom: 0px;">請於此線簽名</i>
                </div>
                <h4>收貨方簽名欄</h4>
                <div style="width: 100%; height: 2cm; border-bottom: 2px solid; position: relative;">
                    <i style="font-size: 14px; color: lightgray; position: absolute; right: 0px; bottom: 0px;">請於此線簽名</i>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    props: {
        show_contents: Boolean,
        core_waybills: Array,
        logo_url: String,
        title: String,
        sub_title: String,
        customer_service_hotline: String,
        blank_value_text: String,
    },
    data() {
        return {
            errors: [],
            senders: [],
            consignees: [],
        }
    },
    mounted() {
    },
    computed: {
        check_core_waybills() {
            var allowed_sender_names = _.map(_.filter(this.$parent.senders, (o) => {
                return o.is_selected
            }), 'sender_name')

            var allowed_consignee_names = _.map(_.filter(this.$parent.consignees, (o) => {
                return o.is_selected
            }), 'consignee_name')

            return _.filter(
                this.core_waybills, (o) => {
                    return allowed_sender_names.includes(o.sender_name) && allowed_consignee_names.includes(o.consignee_company_name)
                }
            )
        },
    },
    methods: {
        latest_condition_time(core_waybill) {
            try {
                return this.human_datetime(core_waybill.condition.updated_at, "MMDDHHmm")
            } catch (e) {
                return "-"
            }
        },
        latest_status_time(core_waybill) {
            try {
                if (core_waybill.latest_status.name == "點交") {
                    return this.human_datetime(core_waybill.latest_status.created_at, "MMDDHHmm")
                } else {
                    return this.latest_condition_time(core_waybill)
                }
            } catch (e) {
                return "-"
            }
        },
    },
    components: {
    }
}
</script>

<style scoped>
table {
    border-color:  black !important;
}
table td, th{
    border-color:  black !important;
}
</style>
